const COMMON_CLASS_PREFIX = 'ocean-ui';
export default {
  resetComponentByConfig(config, componentName, Component) {
    // let buttonConfig = config[componentName] || {};
    let compoentConfig = {
      oceanuiClassName: `${COMMON_CLASS_PREFIX}-${componentName}`,
    };
    let originButtunData = Component.data;
    if (typeof originButtunData === 'undefined') {
      Component.data = function () {
        return compoentConfig;
      };
      return Component;
    }
    if (typeof originButtunData == 'function') {
      Component.data = function () {
        let res = originButtunData.call(this);
        res = { ...res, ...compoentConfig };
        return res;
      };
    } else {
      Component.data = { ...originButtunData, ...compoentConfig };
    }

    return Component;
  },
};
